export default __webpack_public_path__ + "static/media/img-0286-zambia-full-face.a974fb2b.png";